import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { configSectionsInOut } from 'animations-lib';
import { FieldConfigChangedControllerService } from '../../../data-fields/field-config-changed-controller.service';

@Component({
    selector: 'app-blank-field-default',
    templateUrl: './blank-field-default.component.html',
    styleUrls: ['./blank-field-default.component.scss', '../field-options.component.scss'],
    animations: [configSectionsInOut],
    standalone: false
})
export class BlankFieldDefaultComponent implements OnInit {
  @Input() set fieldOptions(defaultEmptyValue: string | undefined) {
    this.initFieldOptions(defaultEmptyValue);
    this.hasChanged = false;
  }
  @Output() fieldOptionsChange = new EventEmitter<string | undefined>();

  defaultEmptyValue: string | undefined;
  expanded = false;
  hasChanged = false;

  constructor(private configChangedControllerService: FieldConfigChangedControllerService) {}

  ngOnInit() {
    this.hasChanged = this.configChangedControllerService.get('BlankFieldDefaultComponent');
  }

  get fieldOptions(): string | undefined {
    return this.defaultEmptyValue;
  }

  updateParent() {
    this.fieldOptionsChange.emit(this.defaultEmptyValue);
    this.configChangedControllerService.update('BlankFieldDefaultComponent', true);
    setTimeout(() => (this.hasChanged = true), 0);
  }

  toggleExpanded(): void {
    this.expanded = !this.expanded;
  }

  private initFieldOptions(defaultEmptyValue: string | undefined) {
    this.defaultEmptyValue = defaultEmptyValue;
  }
}
